<template>
    <basic-container>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="待升级" name="first">
          <el-form
            :model="searchForm"
            ref="searchFormRef"
            label-width="100px"
            label-suffix=":"
            v-show="searchBoxFlag"
          >
            <el-row :gutter="24">
              <el-col :span="6">
                <el-form-item label="所属车场" prop="parkingLotId">
                  <el-select
                    v-model="searchForm.parkingLotId"
                    style="width: 100%"
                    placeholder="所属车场"
                    clearable
                  >
                    <el-option
                      v-for="item in spaceList"
                      :key="item.value"
                      :label="item.title"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>


              <el-col :span="6">
                <el-form-item label="设备编号" prop="deviceCode">
                  <el-input
                    clearable
                    v-model="searchForm.deviceCode"
                    placeholder="设备编号"
                    maxlength="30"
                  ></el-input>
                </el-form-item>
              </el-col>
   
            
              <el-col :span="24">
                <div style="float: right">
                  <el-button
                    type="primary"
                    icon="el-icon-search"
                    @click="searchRecord"
                    size="small"
                  >
                    搜索
                  </el-button>
                  <el-button
                    icon="el-icon-delete"
                    @click="searchClear"
                    size="small"
                  >
                    清空
                  </el-button>
                </div>
              </el-col>
            </el-row>
          </el-form>
          <avue-crud
            :option="option"
            :table-loading="loading"
            :data="data"
            :page.sync="page"
            ref="crud"
            @on-load="onLoad"
            @current-change="currentChange"
            @size-change="sizeChange"
            @refresh-change="onLoad"
            @selection-change="selectionChange"
          >
            
            <template slot="menuRight">
              <searchFromShow
                :searchBoxFlag.sync="searchBoxFlag"
                :removeHeight="searchHeight"
                :reduceHeight="20"
                :option="option"
                :refOption="$refs.crud"
              ></searchFromShow>
            </template>
            <template slot="menu" slot-scope="scope">
                <el-button
                type="text"
                size="small"
                
                @click="remove(scope.row)"
                >
                移除
                </el-button>
            </template>
            <template slot="description" slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                :content="scope.row.address"
                placement="top"
              >
                <div class="txtOver">{{ scope.row.address }}</div>
              </el-tooltip>
            </template>
          </avue-crud>
        </el-tab-pane>
       
      </el-tabs>
  
    
    </basic-container>
  </template>
  <script>
  import { getDictionary } from "@/api/common.js";
  import searchFromShow from "@/components/search-form-show/index";
  import {
    tenantGetList,
    agentGetList,
    propertyGetList,
    areaGetList,
    stationGetList,
    upgradeRecordPage,
    upgradeRecordRemove
  } from "./api/index";
  import AddKeyAdressVue from "./addKeyAdress.vue";
  import { getSpaceTree } from '@/api/v4ward/car/carparkspace';
  export default {
    components: { searchFromShow,AddKeyAdressVue },
    data() {
      return {
        tenantList: [],
        agentList: [],
        propertyList: [],
        areaList: [],
        spaceList: [],
   
        activeName: "first",
        dataSelf:[],
        data:[],
        visible: false,
        recordTittle: "新增",
        configureTittle: "配置",
        searchForm: {
          deviceCode: "",
          tenantId: "",
          agentId: "",
          areaId: "",
          parkingLotId: "",
        },
     
        option: {
        index: true,
        indexLabel: "#",
        page: true,
        height: "auto",
        calcHeight: "auto",
        align: "left",
        menu: true,
        viewBtn: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        border: true,
        column: [
          {
            label: "设备编号",
            prop: "deviceCode",
          },
         
          {
            label: "当前版本",
            prop: "curVersion",
          },
          {
            label: "升级版本",
            prop: "otaVersion",
          },
          {
            label: "升级截止时间",
            prop: "deadTime",
          },
          {
            label: "所属车场",
            prop: "stationName",
          },
          {
            label: "所属租户",
            prop: "tenantName",
          },
          {
            label: "创建时间",
            prop: "createTime",
          },
          
        ],
      },
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0,
        },
       
        loading: false,
  
        searchBoxFlag: true,
        searchHeight: "",
      };
    },
    watch:{
    '$route.path':function(newVal,oldVal){
     
          if(newVal === '/v4ward/carv2/deviceUpgrade/upgrade'){
             this.$refs.crud.$refs.table.doLayout()
          }
        }
  },
    created() {
      this.initData();
      
    },
    mounted() {
      this.calcHeight();
    },
    methods: {
        remove(row){
      this.$confirm('是否进行移除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let formData = new FormData()
            formData.append('id',row.id)
          
            upgradeRecordRemove(formData).then(res=>{
            this.$message({
            type: 'success',
            message: '移除成功!'
          });
          
          this.onLoad()
          })
         
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消移除'
          });          
        });
    },
        
      stationGetList(value) {
        stationGetList({ areaId: value }).then((res) => {
          this.spaceList = res.data;
        });
      },
  
  
  
      searchRecord() {
        this.page.currentPage = 1;
  
        this.onLoad();
      },
      searchClear() {
        this.tool.clearObject(this.searchForm);
      },
      calcHeight() {
        this.searchHeight = this.$refs.searchFormRef.$el.clientHeight;
        this.option.height = this.bodyHeight - this.searchHeight - 279-20;
        console.log(" this.option.height", this.option.height);
      },
      async initData() {
        getSpaceTree().then(res=>{
          this.spaceList = res.data
          if(this.spaceList.length>0){
            this.searchForm.parkingLotId = this.spaceList[0].value
            this.onLoad()
          }
          
        })
      },
      onLoad() {
        if(this.searchForm.parkingLotId!=""){
          this.loading = true;
        upgradeRecordPage(
          Object.assign(
            {},
            { current: this.page.currentPage, size: this.page.pageSize },
            this.searchForm
          )
        )
          .then(({ data }) => {
            this.data = data.records;
            this.page.total = data.total;
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
        }
         
      },
    },
  };
  </script>
  
  <style scoped>
  ::v-deep .avue-crud__right {
    display: flex;
  }
  </style>
  